import { useEffect, useMemo, useRef, useState } from 'react';
import list from '../../assets/images/list.svg';
import calendar from '../../assets/images/calendar-grey.png';
import trello from '../../assets/images/trello-grey.png';
import book from '../../assets/images/classs-img.png';
import arrowRight from '../../assets/images/arrow-right.png';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { StudentDashboardSidebar } from '../../components/StudentDashboardSidebar';
import StudentNavbar from '../../components/StudentNavbar';
import 'react-quill/dist/quill.snow.css';
import {
  forStudent,
  filterClassActivity,
  getClassesActivity,
  getChapterActivity,
  // activityAnswer,
} from '../../Store/api/activities';
import MediaComponent from '../../components/activity/MediaComponent';
import EditorInput from '../../components/activity/EditorInput';
import SideBarBlanks from '../../components/studentDashboard/sideBarBlanks';
import { CustomSelect } from '../../shared/CustomSelect';
import { IndicatorSeparator } from '../../components/dashboard/Tabs/Settings/Subsettings/ActivitySettings';
import DropDown from '../../components/dashboard/Tabs/Settings/Dropdown/DropDown';
import storage from '../../services/storage';
import { ActivityLoadingSkeleton } from '../../shared/ActivityLoadingSkeleton';
import moment from 'moment';
import { canAttempt, calculateLatePenalty } from '../../utils';

/* MCQS */
const questionTypes = {
  mcqs: 'multiple choice',
  fr: 'long response',
  truefalse: 'true and false',
  matching: 'matching',
  blanks: 'fill in the blanks',
  sa: 'short response',
  or: 'order list',
};

const filterActivities = (activities, status) =>
  activities.filter((activity) => {
    return (
      activity.activityAnswers &&
      activity.activityAnswers.some(
        (ans) =>
          !ans.isGraded &&
          ans.answers &&
          ans.answers.length > 0 &&
          (status === 'InProgress'
            ? ans.activityStatus === 'InProgress'
            : ans.activityStatus !== 'InProgress')
      )
    );
  });

const StudentActivities = () => {
  const { search = '' } = useLocation();
  const queryParam = search?.split('?')?.[1] || '';

  const nevigate = useNavigate();
  const dispatch = useDispatch();
  const user = storage.get('user');
  const [setGotoSubject] = useState(1);
  const [loading, setLoading] = useState(true);
  const [setSideBarEvent] = useState('activities');
  const [selectChapId, setSelectChapId] = useState('');
  const [selectClassId, setSelectClassId] = useState('');
  const [filterClasses, setFilterClasses] = useState([]);
  const [filterChapter, setFilterChapter] = useState([]);

  const [reduxActivity, setReduxActivity] = useState([]);
  const [allActivities, setAllActivites] = useState(true);
  const [dueNextValue, setDueNextValue] = useState(false);
  const [duePastValue, setDuePastValue] = useState(false);
  const [dueCompleted, setDueCompleted] = useState(false);
  const [activeButton, setActiveButton] = useState('all');
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [submittedValue, setSubmittedValue] = useState(false);
  const [dueInCompleteValue, setDueInCompleteValue] = useState(false);
  // const { activities } = useSelector((state) => state.entities.student.book);
  const [selectedChapterIds, setSelectedChapterIds] = useState([]);
  const [selectedChapterOrders, setSelectedChapterOrders] = useState([]);

  const currentDate = new Date();
  const sevenDaysLater = new Date(currentDate);
  sevenDaysLater.setDate(currentDate.getDate() + 7);

  const handleActivityClick = (activity) => {
    setSelectedActivity(activity);
  };

  useEffect(() => {
    if (queryParam === 'due') {
      setDueNextValue(true);
      setActiveButton('dueNext');
    } else if (queryParam === 'graded') {
      setDueCompleted(true);
      setActiveButton('submitted');
    } else if (queryParam === 'in_complete') {
      setDueInCompleteValue(true);
      setActiveButton('dueInComplete');
    }
  }, [queryParam]);

  useEffect(() => {
    dispatch(
      getClassesActivity({
        onSuccess: (res) => {
          setFilterClasses(res?.data?.data ?? []);
          setLoading(false);
        },
        onError: () => {
          setLoading(false);
        },
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      forStudent({
        onSuccess: (res) => {
          const apiActivities = res.data.data.flatMap((item) => item.activities);
          setReduxActivity(apiActivities);

          setLoading(false);
        },
        onError: (err) => {
          setLoading(false);
        },
      })
    );
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (selectClassId) {
        handleClassClick(selectClassId); // Refetch with new chapters
      }
			const ordersList = filterChapter.filter(item => selectedChapterIds.includes(item._id));
			setSelectedChapterOrders(ordersList.map(item => item.order));
			
    }, 300); // debounce 300ms

    return () => clearTimeout(timeout);
  }, [selectedChapterIds]);

  const filteredActivities = useMemo(() => {
    let filtered = [];

    if (allActivities || queryParam === 'all') {
      filtered = reduxActivity;
    } else if (dueNextValue || queryParam === 'due') {
      filtered = reduxActivity.filter((e) => {
        const assignedDate = new Date(e.assignedDate).setHours(0, 0, 0, 0);
        const currentDate = new Date().setHours(0, 0, 0, 0);
        return (
          assignedDate >= currentDate &&
          e.activityAnswers &&
          e.activityAnswers.length > 0 &&
          e.activityAnswers.some(
            (ans) =>
              (!ans.isGraded && !ans.answers.length) ||
              (ans.answers.length && ans.activityStatus === 'InProgress')
          )
        );
      });
    } else if (dueCompleted || queryParam === 'graded') {
      filtered = reduxActivity.filter((activity) => {
        if (activity.activityAnswers && activity.activityAnswers.length > 0) {
          const lastActivity = activity.activityAnswers[activity.activityAnswers.length - 1];
          if (lastActivity && lastActivity.isGraded && lastActivity.answers) {
            return true;
          }
        }
        return false;
      });
    } else if (dueInCompleteValue || queryParam === 'in_complete') {
      filtered = filterActivities(
        reduxActivity.filter((e) => {
          const assignedDate = new Date(e.assignedDate).setHours(0, 0, 0, 0);
          const currentDate = new Date().setHours(0, 0, 0, 0);
          if (assignedDate >= currentDate || !e.activityAnswers?.length) {
            return e.activityAnswers.some(
              (answer) =>
                !answer.isGraded &&
                (!answer.answers.length ||
                  (answer.answers.length && answer.activityStatus === 'InProgress'))
            );
          }
        }),
        'InProgress'
      );
    } else if (duePastValue) {
      filtered = reduxActivity.filter((e) => {
        const assignedDate = new Date(e.assignedDate).setHours(0, 0, 0, 0);
        const currentDate = new Date().setHours(0, 0, 0, 0);
        if (assignedDate >= currentDate || !e.activityAnswers?.length) return false;
        return e.activityAnswers.some(
          (answer) =>
            !answer.isGraded &&
            (!answer.answers.length ||
              (answer.answers.length && answer.activityStatus === 'InProgress'))
        );
      });
    } else if (submittedValue) {
      filtered = filterActivities(reduxActivity, 'Submitted');
    }
    return filtered;
  }, [
    reduxActivity,
    allActivities,
    dueNextValue,
    dueCompleted,
    dueInCompleteValue,
    duePastValue,
    submittedValue,
    queryParam,
  ]);

  const handleClassClick = (classId) => {
    // If the user explicitly selects a class:
    setSelectedClass(classId);
    // Reset chapter selection because class changed
    setSelectedChapterIds([]);
		setSelectedChapterOrders([]);
    // Fetch chapters & activities for this class
    fetchChaptersAndActivities(classId, []);
  };
  const handleChapterChange = (chapterId) => {
    setSelectedChapterIds((old) =>
      old.includes(chapterId) ? old.filter((c) => c !== chapterId) : [...old, chapterId]
    );
		
  };
  useEffect(() => {
    if (selectedClass) {
      // Fetch activities with the updated selectedChapterIds
      setLoading(true);
      dispatch(
        filterClassActivity({
          classid: selectedClass,
          chapterIds: selectedChapterIds,
          onSuccess: (res) => {
            const apiActivities = res.data.data.flatMap((item) => item.activities);
            setReduxActivity(apiActivities);
            setLoading(false);
          },
          onError: () => {
            setLoading(false);
          },
        })
      );
    }
  }, [selectedChapterIds, selectedClass, dispatch]);

  /* Button Filter Activities... */
  const handleButtonClick = (buttonType) => {
    switch (buttonType) {
      case 'all':
        setAllActivites(true);
        setDueNextValue(false);
        setDuePastValue(false);
        setSubmittedValue(false);
        setDueInCompleteValue(false);
        setDueCompleted(false);
        break;
      case 'dueNext':
        setAllActivites(false);
        setDueNextValue(true);
        setDuePastValue(false);
        setSubmittedValue(false);
        setDueInCompleteValue(false);
        setDueCompleted(false);
        break;
      case 'submitted':
        setAllActivites(false);
        setDueNextValue(false);
        setDuePastValue(false);
        setSubmittedValue(true);
        setDueInCompleteValue(false);
        setDueCompleted(false);
        break;
      case 'duePast':
        setAllActivites(false);
        setDueNextValue(false);
        setDuePastValue(true);
        setSubmittedValue(false);
        setDueInCompleteValue(false);
        setDueCompleted(false);
        break;
      case 'dueCompleted':
        setAllActivites(false);
        setDueNextValue(false);
        setDuePastValue(false);
        setSubmittedValue(false);
        setDueInCompleteValue(false);
        setDueCompleted(true);
        break;
      case 'dueInComplete':
        setAllActivites(false);
        setDueNextValue(false);
        setDuePastValue(false);
        setSubmittedValue(false);
        setDueInCompleteValue(true);
        setDueCompleted(false);
        break;
      default:
        break;
    }
    setActiveButton(buttonType);
    setSelectedActivity(null);
  };
  const CorrectIncorrect = (selectedActivity) => {
    let totalCorrectAnswers = 0;
    let totalIncorrectAnswers = 0;
    let totalAnswers = 0;

    // Check if selectedActivity and activityAnswers are valid
    if (selectedActivity && Array.isArray(selectedActivity.activityAnswers)) {
      selectedActivity.activityAnswers.forEach((activityAnswer) => {
        if (Array.isArray(activityAnswer.answers)) {
          activityAnswer.answers.forEach((answer) => {
            if (answer.isGraded) {
              if (answer.isCorrect) {
                totalCorrectAnswers++;
              } else {
                totalIncorrectAnswers++;
              }
            }
            totalAnswers++;
          });
        } else {
          console.error(
            'activityAnswer.answers is not an array or is undefined',
            activityAnswer.answers
          );
        }
      });
    } else {
      console.error(
        'selectedActivity or activityAnswers is undefined or not an array',
        selectedActivity
      );
    }

    return {
      totalCorrectAnswers,
      totalIncorrectAnswers,
      totalAnswers,
    };
  };

  const qusestionStatus = selectedActivity
    ? CorrectIncorrect(selectedActivity)
    : { totalCorrectAnswers: 0, totalIncorrectAnswers: 0, totalAnswers: 0 };

  /* For Redo activity */

  const getSelectedActivityLabel = () => {
    if (!selectedActivity.activityAnswers) {
      return 'Start';
    }

    const firstAnswer = selectedActivity.activityAnswers[0]; // Assuming the first answer is relevant
    const assignedDate = new Date(selectedActivity.assignedDate).setHours(0, 0, 0, 0);
    const currentDate = new Date().setHours(0, 0, 0, 0);

    if (firstAnswer?.isGraded) {
      if (firstAnswer.grade === 100) {
        return 'View'; // Perfect grade
      } else if (firstAnswer.grade < 100 && assignedDate >= currentDate) {
        return 'Redo'; // Needs redo and the assigned date is today or in the future
      } else {
        return 'View'; // Needs redo but the assigned date is in the past
      }
    }

    return 'Start'; // Default to start
  };

  const options = useMemo(
    () =>
      filterClasses.map((cls) => ({
        label: cls.courseName + '  |  ' + cls.courseNumber,
        value: cls._id,
      })) || [],
    [filterClasses]
  );
  useEffect(() => {
    dispatch(
      getClassesActivity({
        onSuccess: (res) => {
          const classes = res?.data?.data ?? [];
          setFilterClasses(classes);
          setLoading(false);

          // 2. If there's at least one class, set default and load its chapters & activities
          if (classes.length > 0) {
            // For example, pick the first class as default:
            const defaultClassId = classes[0]._id;
            setSelectedClass(defaultClassId);
            // Clear any previous chapter selections:
            setSelectedChapterIds([]);
            // Fetch chapters & activities for default:
            fetchChaptersAndActivities(defaultClassId, []); // pass empty chapter selection initially
          }
        },
        onError: () => {
          setLoading(false);
        },
      })
    );
  }, [dispatch]);

  const fetchChaptersAndActivities = (classId, chapterIds) => {
    setLoading(true);

    // Fetch filtered activities
    dispatch(
      filterClassActivity({
        classid: classId,
        chapterIds: chapterIds,
        onSuccess: (res) => {
          const apiActivities = res.data.data.flatMap((item) => item.activities);
          setReduxActivity(apiActivities);
          setLoading(false);
        },
        onError: () => {
          setLoading(false);
        },
      })
    );

    // Fetch chapters for this class
    dispatch(
      getChapterActivity({
        id: classId,
        onSuccess: (res) => {
          setFilterChapter(res?.data?.data ?? []);
        },
        onError: () => {},
      })
    );
  };

  return (
    <>
      <div className='wrapper'>
        {/* <!-- Page Sidebar --> */}
        <StudentDashboardSidebar
          sideBarEvent={'activities'}
          setSideBarEvent={setSideBarEvent}
          setGotoSubject={setGotoSubject}
        />
        {/* <!-- Page Content Holder --> */}
        <div id='content'>
          <div className='content_dashborad_inner'>
            {/* <!-- navbar --> */}
            <StudentNavbar sideBarEvent={'activities'} setSideBarEvent={setSideBarEvent} />
            <div className='main_section_content me-3 ms-0'>
              <div className='center_content center_content_h90vh ' style={{ marginTop: '15px' }}>
                <div className='header_all_activity'>
                  <div className='header_innder'>
                    <div className='d-flex align-items-center gap-3'>
                      <img src={list} alt='list' />
                      <img src={calendar} alt='calendar' />
                      <img src={trello} alt='trello' />
                    </div>
                    <div className='selct_box_main w-30'>
                      <div className='dropdown_wrapper_custom w-100'>
                        <CustomSelect
													customStyle={{
														menu: (provided) => ({
															...provided,
															marginTop: 0, // This removes the gap between control and dropdown
															border: "1px solid grey"
														}),
													}}
                          className='w-100 mb-0'
                          options={options}
                          placeholder='Class Select'
                          components={{ IndicatorSeparator }}
                          handleChange={(event) => handleClassClick(event.value)}
                          value={options.find((item) => item.value === selectedClass) || null}
                        />
                      </div>
                    </div>

                    <div className='selct_box_main mr-0 w-25'>
                      <div className='form-group w-100'>
                        <DropDown
                          type='checkbox'
													title={!selectedChapterOrders.length ? 'Chapter select' : `Chapter ${selectedChapterOrders.length > 6 ? selectedChapterOrders.slice(0, 6).join(", ") +"...": selectedChapterOrders.join(", ")}`}
                          dropdownClassName='custom-dropdown-class m-0'
                          options={filterChapter.map((e) => ({
                            value: e._id,
                            title: <span className='font-inter fs-14 mb-0 fw-500'>{`Chapter ${e.order}`}</span>,
                            isChecked: selectedChapterIds.includes(e._id),
                          }))}
                          onChange={(e) => {
                            handleChapterChange(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='all_active_button'>
                    <button
                      type='button'
                      onClick={() => handleButtonClick('all')}
                      className={`all-buttons ${activeButton === 'all' ? 'active-button' : ''}`}
                    >
                      All activities
                    </button>
                    <button
                      type='button'
                      onClick={() => handleButtonClick('dueNext')}
                      className={`all-buttons
                        ${activeButton === 'dueNext' ? 'active-button' : ''}`}
                    >
                      Due next
                    </button>
                    <button
                      type='button'
                      onClick={() => handleButtonClick('submitted')}
                      className={`all-buttons ${
                        activeButton === 'submitted' ? 'active-button' : ''
                      }`}
                    >
                      Submitted
                    </button>
                    <button
                      type='button'
                      onClick={() => handleButtonClick('duePast')}
                      className={`all-buttons ${
                        activeButton === 'duePast' ? 'active-button' : ''
                      }`}
                    >
                      Past due
                    </button>
                    <button
                      type='button'
                      onClick={() => handleButtonClick('dueCompleted')}
                      className={`all-buttons ${
                        activeButton === 'dueCompleted' ? ' active-button' : ''
                      }`}
                    >
                      Completed
                    </button>
                    <button
                      type='button'
                      onClick={() => handleButtonClick('dueInComplete')}
                      className={`all-buttons ${
                        activeButton === 'dueInComplete' ? ' active-button' : ''
                      }`}
                    >
                      Incomplete
                    </button>
                  </div>
                </div>

                <div className='activities_due_next p-0 cursor_default'>
                  {renderActivities(filteredActivities)}
                </div>
              </div>
              <div className='right_content feadback_box right_content_main mrl-0'>
                <div
                  className={`box_border ${
                    selectedActivity ? 'date_Schedule' : `empty-act-height`
                  } cursor_default`}
                  style={{
                    border: '1px solid var(--Grey-200, #F0F0EF)',
                    background: 'var(--White, #FFF)',
                    boxShadow: 'none',
                    paddingTop: '16px',
                  }}
                >
                  {selectedActivity ? (
                    <>
                      <div className='head_line'>
                        <h1 className='ft_12 fw-700 d-flex'>
                          {selectedActivity?.classInfo?.[0]?.courseName}
                          <span
                            className='fw-700 '
                            style={{
                              color: getStatusText(selectedActivity).color,
                            }}
                          >
                            {getStatusText(selectedActivity).text.toUpperCase()}
                          </span>
                        </h1>
                        {/* {selectedActivity.answers.length > 0 && ( */}
                        <h5 className='d-flex align-items-center justify-content-between mb-20'>
                          <span>
                            <span className='right_content_Grade fw-500'>Grade:</span>{' '}
                            <span className='right_content_Grade fw-400'>
                              {getPercentage(selectedActivity)} | {''}{' '}
                              {qusestionStatus.totalCorrectAnswers} correct -{' '}
                              {qusestionStatus.totalIncorrectAnswers} incorrect
                              {''}
                            </span>
                          </span>{' '}
                          {canAttempt(selectedActivity) && (
                            <a href='#!' className='right_content_Grade fw-500'>
                              <u
                                className='fw-500'
                                onClick={() => {
                                  nevigate(`/studentfocusedmode/${selectedActivity._id}`);
                                }}
                              >
                                {getSelectedActivityLabel()}
                              </u>
                            </a>
                          )}
                        </h5>
                        {/* )} */}
                      </div>
                      <div className='form-group feadback_input mb-20'>
                        <label className='ft_12 txt_cap'>Instructor's Feedback</label>
                        <input
                          className='form_control form_control_std2 std_place'
                          placeholder='Response goes here'
                          disabled={!!(user.role.toLowerCase() === 'student')}
                        />
                      </div>

                      <div className='question_box_new  '>
                        <div className='cursor_default'>
                          <h5 className='event-less mb-0'>
                            {selectedActivity.graded}-graded
                            <span
                              style={{
                                color: getStatusText(selectedActivity).color,
                              }}
                            >
                              {getStatusText(selectedActivity).text.toUpperCase()}
                            </span>
                          </h5>{' '}
                          <a href='#!' className='ft_10 mb-0 mt_8 text_grey'>
                            {`chapter ${selectedActivity.chapter.order}${
                              selectedActivity?.section
                                ? ` Section ${selectedActivity?.section?.order}`
                                : ''
                            }`}
                          </a>
                          <h1 className='ft_14 mt_16 fw-700 txt_cap'> {selectedActivity.title}</h1>
                          <p className='ft_12 mb-0 mb-2 pdt-4 d-flex justify-content-between align-Items-center'>
                            <span className='points_answer'>
                              {/* {selectedActivity.answers.length > 0 ? ( */}
                              <b>{selectedActivity.score} pts | </b>
                              {/* ) : (
                              ""
                            )} */}
                              {selectedActivity.questions.length} questions
                            </span>
                          </p>
                          {/* {selectedActivity?.activityInstructionUrl && (
                            <div style={{ justifyContent: 'center', display: 'flex' }}>
                              <div style={{ width: '100%' }}>
                                {['text', 'image', 'video', 'audio'].includes(
                                  selectedActivity?.activityInstructionsType
                                ) && (
                                  <MediaComponent
                                    media={{
                                      url: selectedActivity?.activityInstructionUrl || '',
                                      type: selectedActivity?.activityInstructionsType || 'text',
                                    }}
                                    mode='student'
                                  />
                                )}
                              </div>
                            </div>
                          )} */}
                          <div className='chapter_wrap'>
                            <div className='more_question'>
                              <p className='ques_answer mb-0'>{selectedActivity?.description}</p>
                              {selectedActivity.questions.map((question, questionIndex) => (
                                <div className='other_Wrap_question' key={questionIndex}>
                                  <ActivityQuestions
                                    questionTypes={questionTypes}
                                    question={question}
                                    questionIndex={questionIndex}
                                    selectedActivity={selectedActivity}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className='right_content_Grade fw-400' style={{ textTransform: 'none' }}>
                      Select an activity to view details
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  function getStatusText(activity) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const isDueNext =
      new Date(activity.assignedDate) >= currentDate &&
      activity.activityAnswers.length &&
      activity.activityAnswers.some((e) => !e.isGraded && !e.answers.length);

    const isSubmitted =
      activity.activityAnswers.length &&
      activity.activityAnswers.some(
        (ans) =>
          !ans.isGraded &&
          ans.answers &&
          ans.answers.length > 0 &&
          ans.activityStatus !== 'InProgress'
      );

    const isPastDue =
      new Date(activity.assignedDate) < currentDate &&
      (!activity.activityAnswers.length ||
        activity.activityAnswers.some(
          (answer) =>
            // Not graded
            !answer.answers.length || // No answers
            (answer.answers.length && answer.activityStatus === 'InProgress')
        ));

    const isCompleted =
      activity.activityAnswers.length > 0 && activity.activityAnswers.some((e) => e.isGraded);

    const isInProgress =
      activity.activityAnswers.length > 0 &&
      activity.activityAnswers.some((ans) => ans.activityStatus === 'InProgress' && !ans.isGraded);

    /* For Date format */
    const assignedDate = new Date(activity.assignedDate);
    const month = (assignedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = assignedDate.getDate().toString().padStart(2, '0');
    const year = assignedDate.getFullYear().toString().slice(-2);
    const formattedDate = `${month}.${day}.${year}`;

    if (isDueNext) {
      return {
        text: `Due ${formattedDate}`,
        color: '#4A4540',
      };
    } else if (isPastDue) {
      return { text: 'Past Due', color: '#AE2604' };
    } else if (isInProgress) {
      return { text: `Due ${formattedDate}`, color: '#4A4540' }; // Choose a color for In Progress
    } else if (isSubmitted) {
      return { text: 'Submitted', color: '#FC9003' };
    } else if (isCompleted) {
      return { text: 'Completed', color: '#0A5C59' };
    } else {
      return { text: 'Incomplete', color: '#AE2704' };
    }
  }

  // const status = getStatusText(activity);

  function renderActivities(activities = []) {
    const getActivityLabel = (activityId) => {
      const activity = activities.find((activity) => activity._id === activityId);

      if (activity?.activityAnswers) {
        const firstAnswer = activity?.activityAnswers?.[0]; // Assuming we're checking the first answer
        const assignedDate = new Date(activity.assignedDate).setHours(0, 0, 0, 0);
        const currentDate = new Date().setHours(0, 0, 0, 0);

        if (firstAnswer?.isGraded) {
          if (firstAnswer.grade === 100) {
            return 'View'; // Perfect grade
          } else if (firstAnswer.grade < 100 && assignedDate >= currentDate) {
            return 'Redo'; // Needs redo and the assigned date is valid
          } else {
            return 'View'; // Needs redo but assigned date is in the past
          }
        }
      }

      return 'Start'; // Default to start
    };
    const canAttempt = (act) => {
      // Safely get the first answer, or null if none:
      const firstAnswer = act?.activityAnswers?.length ? act.activityAnswers[0] : null;

      // Safely get activitySettings or default to {}:
      const activitySettings = firstAnswer?.classId?.activitySettings || {};
      const { isPastDueAllowed = false, multipleAttempts = {} } = activitySettings;

      const { isAllowed = false, count = 0 } = multipleAttempts;

      // Safely get previousAnswers length and isSubmitted:
      const prevCount = firstAnswer?.previousAnswers?.length || 0;
      const isSubmitted = firstAnswer?.isSubmitted || false;

      let submitCount = prevCount + (isSubmitted ? 1 : 0);
      let canAtt = true;

      // If assignedDate is before today, consult isPastDueAllowed:
      if (act?.assignedDate && moment(act.assignedDate).isBefore(moment(), 'day')) {
        canAtt = Boolean(isPastDueAllowed);
      }

      // If not allowed multiple attempts and already submitted, or if allowed but count reached:
      if ((!isAllowed && isSubmitted) || (isAllowed && submitCount >= Number(count))) {
        canAtt = false;
      }

      return canAtt;
    };

    return (
      <div>
        {loading ? (
          [...new Array(4)].map((item) => <ActivityLoadingSkeleton key={item} />)
        ) : (
          <>
            {activities.length > 0 ? (
              <div>
                {activities.map((activity, index) => {
                  const filteredQuestions = activity?.questions?.filter(
                    (question) =>
                      question?.type && ['blanks', 'mcqs', 'truefalse'].includes(question.type)
                  );

                  // Get the length of the filtered questions
                  const autoGraded = filteredQuestions?.length || 0;

                  // Safely filter questions with type "fr"
                  const teacherGraded =
                    activity?.questions?.filter((question) => question?.type === 'fr').length || 0;
                  return (
                    <div key={index} className='Definition_of_terms'>
                      <div className='img_Wrap_book'>
                        <img
                          src={
                            activity?.book?.coverImage ||
                            activity?.book?.activityBookCoverUrl ||
                            book
                          }
                          alt='book'
                        />
                      </div>
                      <div className='text_right'>
                        <div className='book_text' style={{ width: '41%' }}>
                          <h6 className='ft_12 fw-700'>{activity?.classInfo?.[0]?.courseName}</h6>
                          <h5 className='ft_12 fw-500 mt_10 cursor'>
                            <u>{`chapter ${activity?.chapter?.order} ${
                              activity?.section ? ` Section ${activity?.section?.order}` : ''
                            }`}</u>
                          </h5>
                          <h1 className='ft_18 fw-700 mt_10 mb-0' title={activity.title}>
                            {activity.title.length > 32
                              ? `${activity.title.slice(0, 32)}...`
                              : activity.title}
                          </h1>
                        </div>

                        <div className='price_box_total book_percent'>
                          <h1 className='percent_marks'>
                            {getPercentage(activity)
                              ? getPercentage(activity)
                              : activity.percentage}
                          </h1>
                        </div>

                        <div className='book_text text-end book_graded'>
                          <div className='d-flex justify-content-between'>
                            {moment(activity?.assignedDate).isBefore(moment(), 'D') ||
                            activity.activityAnswers?.[0]?.isSubmitted ? (
                              <h6 style={{ color: '#AE2604' }} className='ft_12 fw-700'>
                                {activity.activityAnswers?.[0]?.isSubmitted
                                  ? activity.activityAnswers?.[0]?.penaltyCalculated || 0
                                  : calculateLatePenalty(activity)}
                                % late penalty
                              </h6>
                            ) : (
                              <h6></h6>
                            )}
                            <h6
                              className={`ft_12 fw-700`}
                              style={{ color: getStatusText(activity).color }}
                            >
                              {getStatusText(activity).text}
                            </h6>
                          </div>
                          <h5 className='ft_12 fw-500 mt_10 mb-16'>
                            {autoGraded} auto-graded, {teacherGraded} teacher-graded
                          </h5>
                          <h5 className='ft_12 fw-500 mb-0'>
                            {canAttempt(activity) && (
                              <a
                                href='#!'
                                className='ft_12 fw-500'
                                onClick={() => {
                                  nevigate(`/studentfocusedmode/${activity._id}`);
                                }}
                              >
                                {getActivityLabel(activity._id)}
                              </a>
                            )}{' '}
                            <a
                              href='#!'
                              className='ft_12 fw-500'
                              onClick={() => handleActivityClick(activity)}
                            >
                              details
                              <img src={arrowRight} alt='arrow-right' />
                            </a>
                          </h5>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className='no-activity no-actv'>No activities assigned</div>
            )}
          </>
        )}
      </div>
    );
  }

  function getPercentage(activity) {
    const grade = activity?.activityAnswers?.[0]?.grade;
    const isSubmitted =
      activity.activityAnswers.length > 0 && activity.activityAnswers.every((ac) => !ac.isGraded);
    const isPastDue =
      new Date(activity.assignedDate) < currentDate &&
      activity.activityAnswers.every((ac) => !ac.isGraded);
    const isCompleted =
      activity.activityAnswers.length > 0 &&
      activity.activityAnswers.some((ac) => ac.isGraded && ac.answers.length);
    if (isSubmitted) {
      return '--%';
    } else if (isPastDue) {
      return '0%';
    } else if (isCompleted) {
      return `${Math.round(grade)}%`;
    } else {
      // Default case: Show all three conditions' statuses
      return '';
    }
  }

  function ActivityQuestions({ questionTypes, question, questionIndex, selectedActivity }) {
    const inputRefs = useRef([]); // To keep track of input elements
    const [error] = useState({});
    const [activityAnswers] = useState(selectedActivity.activityAnswers);
    const [isExpanded, setIsExpanded] = useState(false);
    const activityAnswersWithFRType = selectedActivity?.activityAnswers.filter((activityAnswer) =>
      activityAnswer.answers.some((ans) => ans.type === 'fr' || ans.type === 'sa')
    );

    // Now, extract only the 'fr' type answers
    const frAnswers = activityAnswersWithFRType
      .map((activityAnswer) =>
        activityAnswer.answers.filter((ans) => ans.type === 'fr' || ans.type === 'sa')
      )
      .flat(); // Flatten the array if you want a single array of answers

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };
    const blankAnswer = activityAnswers[0]?.answers.filter(
      (ans) => ans.studentSelectedBanks.length > 0
    );

    return (
      <div className='multipal_choic '>
        <h5 className='quest_type fw-600 ft_10  mb-2'>{questionTypes[question.type]}</h5>
        <h1 className='ft_14 mrb-3  first_ltr_capital' style={{ textAlign: 'start' }}>
          {' '}
          {question.text}
        </h1>
        {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
          <div style={{ width: '100%' }}>
            {['text', 'image', 'video', 'audio'].includes(question?.questionInstructionsType) && (
              <MediaComponent
                media={{
                  url: question?.questionMediaTypeUrl || '',
                  type: question?.questionInstructionsType || 'text',
                }}
                mode='student'
              />
            )}
          </div>
        </div> */}
        <div className='ft_12 mb-0 d-flex justify-content-between align-Items-center'>
          <span className='points_answer'>
            <b>{question.score}</b> pts |{' '}
            <b>
              {question.type === 'mcqs' ? (
                <>{question.options.length} answer</>
              ) : (
                <>{questionTypes[question.type]}</>
              )}
            </b>
          </span>

          <h4 className='v_more cursor' onClick={toggleExpand}>
            <u>{isExpanded ? 'hide answers' : 'show answers'}</u>
          </h4>
        </div>
        {isExpanded && (
          <>
            {question.type === 'mcqs' || question.type === 'truefalse' ? (
              <div
                className='mcqs-parent-student-focused mr-tp-bt'
                style={{
                  display: question.type === 'truefalse' ? 'flex' : '', // Set 'flex' when 'question.type' is 'truefalse'
                  flexWrap: question.type === 'truefalse' ? 'wrap' : 'nowrap', // Set 'wrap' when 'question.type' is 'truefalse'
                }}
              >
                {question.options.map((option, index) => {
                  // Find the correct answer object for this question
                  const answerData = activityAnswers
                    .find((activityAnswer) =>
                      activityAnswer.answers.find((answer) => answer.question === question._id)
                    )
                    ?.answers.find((answer) => answer.question === question._id);

                  return (
                    <div
                      className={`mcqs-child cursors ${
                        ['image', 'video'].includes(option.type) && 'pdb-0'
                      } ${answerData?.answerIndex === index ? 'parent-boarder selected' : ''}`}
                      style={{
                        width: question.type === 'truefalse' ? '48%' : '100%',
                      }}
                      key={index}
                    >
                      <div
                        className={`first_child `}
                        style={{ paddingBottom: '0px', cursor: 'default' }}
                      >
                        <div className='option_index'>{String.fromCharCode(65 + index)}</div>
                        <div className='child-b'>{option.text}</div>
                      </div>
                      {['image', 'video', 'audio'].includes(option.type) && (
                        <MediaComponent media={option} mode={'student'} />
                      )}
                    </div>
                  );
                })}
              </div>
            ) : ['fr', 'mix', 'sa'].includes(question.type) ? (
              // Add a check to ensure answerDatad is defined
              <>
                <EditorInput
                  answersRead={frAnswers[0]?.answerText || ''} // Pass as a string, not an array
                  isRead={true}
                  question={question}
                  mode='assign'
                />
              </>
            ) : (
              question.type === 'blanks' && (
                <SideBarBlanks
                  question={question}
                  error={error}
                  inputRefs={inputRefs}
                  blankAnswer={blankAnswer}
                  questionIndex={questionIndex}
                />
              )
            )}
            {/*  {question.type === "mcqs" && (
            <div className="saved-correct mr-tp-bt">
              <span>Saved</span>
              <div>
          Correct <img src={checkMark} alt="" />
        </div>
            </div>
          )} */}
            {/*   {question.type === "fr" && (
            <div className="saved-correct " style={{marginTop: "-20px"}}>
              <span>Saved</span>
              <div>To be graded</div>
            </div>
          )} */}
          </>
        )}
        {question.type !== 'mcqs' && (
          <div className='form-group feadback_input ' style={{ marginTop: '12px' }}>
            <label className='quest_type fw_500  '>Instructor feedback</label>
            <input
              className='form_control form_control_std std_place_name'
              placeholder='Response goes here'
              disabled={!!(user.role.toLowerCase() === 'student')}
            />
          </div>
        )}
      </div>
    );
  }
};
export default StudentActivities;
